$(function(){
	if ($('.mypage').length > 0){
		if ($('.input-target-rest-count').length > 0){
			// 残り文字数
			setRestCount($('.input-target-rest-count'));
			$('.input-target-rest-count').bind('keydown keyup change', function(){
				setRestCount($(this));
			});
			function setRestCount($oInput){
				var iLengthNow  = $oInput.val().length;
				var iMaxLength = $oInput.attr('maxlength');
				$oInput.parent().find('.rest-count').text(iMaxLength - iLengthNow);
			}
		}
	}
	if ($('.birthday-datetime').length > 0){
		$.datetimepicker.setLocale('ja');
		$(".birthday-datetime").datetimepicker({
			timepicker:false,
			format:'Y/m/d',
			defaultDate:'2020-01-01',
		});
	}
});
